import { Colors } from '../consts/Colors.js';
import AbstractScene from './AbstractScene.js';

// Prefabs
import ButtonRounded from '../prefabs/ButtonRounded.js';
import MissionTitle from '../prefabs/MissionTitre.js';
import NavTitre from '../prefabs/NavTitre.js';
import BlueMessageBox from '../prefabs/BlueMessageBox.js';
import ChaineSlider from '../prefabs/ChaineSlider.js';
import AnswerFeedBack from '../prefabs/AnswerFeedBack.js';

// Data
import quimangequiData from '../data/Mission3.js';
import { Sizes } from '../consts/Sizes.js';
import { tags } from '../consts/Tags.js';
import { get } from 'lodash';

export default class Mission3 extends AbstractScene {
    constructor() {
        super({
            key: 'Mission3',
        });
    }
    init(data) {
        this._init(data);
        this.currentIndex = 0;
        this.isCorrect = false;
        this.showEnd = false;
        this.xOffset = 0;
        this.xOffsetCenter = 0;
        this.feedbackLetters = [];

        this.ombreXPositions = [500, -250, -870, -1600, -1575, -2350];
        this.ombreYPositions = [305, 260, 350, 520, 110, 325];
    }

    preload() {
        this._preload();
        this.videoKey = 'rorqualVideo';
        this.preTarget = () => this.scene.start('Mission2');
        this.postTarget = () => {
            this.showIntro();
        };
        this.allControls = [];
        this.isPlaying = false;
        this.isDraging = false;
        this.isPaused = false;
    }

    update() {
        super.update();
    }

    create() {
        this.cameras.main.setBackgroundColor(Colors.Elmt.Beige);
        this.cameras.main.fadeIn(1000);

        this.sceneContainer = this.add.container(this.width / 2, this.height / 2);

        // background
        this.background = this.add.image(0, 0, 'background-activite-2b').setOrigin(0.5);

        this.sceneContainer.add(this.background);

        // mission data
        this.missionData = this.getMissionData(quimangequiData);
        this.videoKey = this.getText('Mission3', 'videoKey');

        this.showVideo(this.videoKey);
    }

    showIntro() {
        this.sceneContainer = this.add.container(this.width / 2, this.height / 2);

        // background
        this.background = this.add.image(0, 0, 'background-activite-3').setOrigin(0.5);

        this.sceneContainer.add(this.background);

        const navTitre = this.add.existing(
            new NavTitre(this, 200, 0, '3', this.getText('Mission3', 'titre'), this.scaleX)
        );

        navTitre.showWithAnimation();

        // Fog (créé invisible au départ)
        const fog = this.add.graphics();
        const containerWidth = this.sceneContainer.width || this.scale.width;
        const containerHeight = this.sceneContainer.height || this.scale.height;

        const fogStartY = containerHeight * 0.5 - containerHeight / 2;
        const fogEndY = containerHeight / 2;
        const fogHeight = fogEndY - fogStartY;

        for (let i = 0; i < fogHeight; i++) {
            const alpha = (i / fogHeight) * 0.8;
            fog.fillStyle(Colors.Elmt.DarkBlue, alpha);
            fog.fillRect(-containerWidth / 2, fogStartY + i, containerWidth, 1);
        }

        this.sceneContainer.add(fog);

        // MissionTitle au-dessus
        this.missionTitle = new MissionTitle(
            this,
            0,
            0,
            3,
            this.getText('Mission4', 'mission'),
            this.getText('Mission3', 'titre'),
            this.getText('Mission3', 'intro'),
            this.scaleX
        );
        this.missionTitle.setDepth(2);

        this.sceneContainer.add(this.missionTitle);
        // Bouton
        const button = this.add.existing(
            new ButtonRounded(
                this,
                458 * this.scaleX + 86,
                this.cameras.main.height - 32 - 32,
                86 * 2,
                32 * 2,
                this.getText('Mission3', 'buttonLabel1'),
                Colors.Text.DarkBlue,
                Colors.Elmt.White,
                false,
                Colors.Text.White,
                true,
                false,
                'arrow-right',
                null
            )
        );
        button.setAlpha(0); // Start invisible

        // ▶️ Sequence d'animations
        this.missionTitle.animateIn(); // Animation du titre de la mission

        this.tweens.add({
            targets: button,
            alpha: 1,
            duration: 1000,
            ease: 'Sine.easeIn',
        });

        this.uiElements = [fog, this.missionTitle, button];
        button.setInteractive({ cursor: 'pointer' }).on('pointerdown', () => {
            this.input.enabled = false;
            // Fade out tout sauf la nav
            this.tweens.add({
                targets: this.uiElements,
                alpha: 0,
                duration: 500,
                onComplete: () => {
                    this.tweens.add({
                        targets: this.background,
                        alpha: 0,
                        duration: 500,
                        onComplete: () => {
                            this.background.setTexture('background-activite-2b').setOrigin(0, 0);
                            this.background.y = -this.height;
                            this.background.x = -this.width / 2;
                            this.tweens.add({
                                targets: this.background,
                                alpha: 1,
                                duration: 500,
                                onComplete: () => {
                                    this.addConsigne();
                                    this.input.enabled = true;
                                },
                            });
                        },
                    });
                },
            });
        });
    }

    addConsigne() {
        this.isClosing = false;
        const elementsToAnimate = [];

        // add cadre consigne
        const cadre = this.add
            .image(this.width / 2, this.height / 2, 'cadre-consigne-activite-1')
            .setOrigin(0.5, 0.5)
            .setScale(0);
        elementsToAnimate.push(cadre);

        // add consigne text
        const texte = new BlueMessageBox(
            this,
            this.cameras.main.centerX,
            450,
            this.getText('Mission3', 'consigne')
        );

        // add icone close
        const close = this.add
            .image(this.width / 2, 70 * 2 + 64 / 2, 'cta-close')
            .setOrigin(0.5, 0.5)
            .setScale(0)
            .setInteractive({ cursor: 'pointer' })
            .on('pointerdown', () => {
                if (this.isClosing) return; // ⛔ empêche de recliquer
                this.isClosing = true;

                this.input.enabled = false;

                const elementsToHide = [cadre, texte, close, loupe];
                let completed = 0;

                elementsToHide.forEach((el) => {
                    this.tweens.add({
                        targets: el,
                        scale: 0,
                        duration: 300,
                        ease: 'Back.easeIn',
                        onComplete: () => {
                            completed++;
                            if (completed === elementsToHide.length) {
                                cadre.destroy();
                                texte.destroy();
                                close.destroy();
                                loupe.destroy();

                                // quand tous les éléments ont disparu, on relance l'activité
                                this.addSlider();

                                // Réinitialise le flag si besoin pour autoriser plus tard
                                this.isClosing = false;

                                // this.input.enabled = true;
                            }
                        },
                    });
                });
            });

        elementsToAnimate.push(close);

        // icone consigne
        const loupe = this.add
            .image(266 * this.scaleX + 50, 112 * 2 + 122 / 2 + 20, 'consigne-activite-3')
            .setOrigin(0.5, 0.5)
            .setScale(0);
        elementsToAnimate.push(loupe);

        // Appliquer l'animation scale up avec rebound
        elementsToAnimate.forEach((el, index) => {
            this.tweens.add({
                targets: el,
                scale: 1,
                duration: 500,
                ease: 'Back.Out',
                delay: index * 100, // léger décalage pour un effet en cascade
            });
        });
    }

    addSlider() {
        this.input.enabled = true;
        this.addSliderText();
        this.addChaineAlimentaire();
        this.addSliderInteraction();
        this.addBurgerMenu(4);
    }

    addSliderText() {
        const isFrench = (this.game.data.language || 'fr') === 'fr';
        let isSingular = false;
        if (this.currentIndex === 0 || this.currentIndex === 3 || this.currentIndex === 5) {
            isSingular = true;
        }
        const phraseConsigne = isSingular
            ? this.getText('Mission3', 'questionConsigne-singular')
            : this.getText('Mission3', 'questionConsigne-plural');

        this.consigneJeuPart1 = this.add
            .rexTagText(this.cameras.main.centerX - 250, 100, phraseConsigne, {
                fontSize: Sizes.Text.h3,
                fontFamily: 'Monteserrat',
                align: 'center',
                color: Colors.Text.White,
                backgroundColor: 'transparent',
                wordWrap: { width: 800 },
                tags: tags,
            })
            .setOrigin(0.5, 0.5);

        this.consigneJeuPart2 = this.add
            .text(
                this.cameras.main.centerX,
                100,
                this.getText('Mission3', `groupeChaine${this.currentIndex}`),
                {
                    fontSize: Sizes.Text.h3,
                    fontFamily: 'MonteserratBold',
                    align: 'center',
                    color: Colors.Text.BleuNovotel,
                    wordWrap: { width: 800 },
                }
            )
            .setOrigin(0.5, 0.5);

        const bounds = this.consigneJeuPart2.getBounds();
        const width = bounds.width;
        const height = bounds.height;

        this.consigneJeuPart1.setPosition(
            this.cameras.main.centerX - width / 2 - 115,
            this.consigneJeuPart1.y
        );

        this.consigneJeuPart3 = this.add
            .rexTagText(this.cameras.main.centerX + width / 2 + 30, 100, '?', {
                fontSize: Sizes.Text.h3,
                fontFamily: 'Monteserrat',
                align: 'center',
                color: Colors.Text.White,
                backgroundColor: 'transparent',
                wordWrap: { width: 800 },
                tags: tags,
            })
            .setOrigin(0.5, 0.5);

        const paddingX = 8;
        const paddingY = 6;

        this.whiteRectangle = this.add
            .rexRoundRectangle(
                this.cameras.main.centerX,
                100,
                width + paddingX * 2,
                height + paddingY * 2,
                8,
                Colors.Elmt.White,
                1
            )
            .setOrigin(0.5);

        this.children.bringToTop(this.consigneJeuPart2);
    }

    addChaineAlimentaire() {
        this.ombreXPositions = [500, -250, -870, -1600, -1575, -2350];
        this.ombreYPositions = [320, 260, 350, 520, 125, 320];

        this.addChaineAlimentaire = this.add
            .image(
                this.ombreXPositions[this.currentIndex],
                this.ombreYPositions[this.currentIndex],
                this.game.data.level === 0 ? `scroll-chaine-activite-3` : `scroll-chaine-activite-b`
            )
            .setOrigin(0, 0.5)
            .setAlpha(0.5);
    }

    addSliderInteraction() {
        const keys = [
            this.getText('Mission3', `imageSlider1`),
            this.getText('Mission3', `imageSlider2`),
            this.getText('Mission3', `imageSlider3`),
            this.getText('Mission3', `imageSlider4`),
            this.getText('Mission3', `imageSlider5`),
            this.getText('Mission3', `imageSlider6`),
        ];

        this.slider = new ChaineSlider(this, this.cameras.main.centerX, 300, keys);

        this.bouteilleActivite = this.add.image(
            this.width - 250,
            this.height - 70,
            this.getText('Mission3', `bouteilleVideImage`)
        );

        this.btnValider = this.add.existing(
            new ButtonRounded(
                this,
                this.width / 2,
                this.cameras.main.centerY + 250,
                102 * 2,
                32 * 2,
                this.getText('Mission3', `buttonLabel2`),
                Colors.Text.DarkBlue,
                Colors.Elmt.White,
                false,
                Colors.Text.White,
                true,
                false,
                'arrow-right',
                null
            )
        );

        /*  const imageReponse = this.add
      .image(
        this.width / 2,
        this.height / 2,
        this.missionData.bonneReponseImage
      )
      .setOrigin(0.5)
      .setDepth(10)
      .setScale(0)
      .setAlpha(0); */

        const imageReponse = this.add
            .existing(
                new AnswerFeedBack(
                    this,
                    this.width / 2,
                    this.height / 2,
                    'bonne-rep-activite-1',
                    this.getText('Mission3', 'bonneReponse')
                )
            )
            .setDepth(10)
            .setScale(0)
            .setAlpha(0);

        const goodAnswers = [3, 0, 5, 1, 4, 2];

        this.btnValider.setInteractive({ cursor: 'pointer' }).on('pointerdown', () => {
            const currentSlide = this.slider.slides[this.slider.currentIndex];

            // ✅ Bloque l'action si ce slide a déjà été validé
            if (currentSlide.tagReponseImage?.alpha === 1) {
                return; // Ne fait rien
            }

            this.isCorrect = this.slider.currentIndex === goodAnswers[this.currentIndex];

            imageReponse.bg.setTexture(
                this.isCorrect ? 'bonne-rep-activite-1' : 'mauvaise-rep-activite-1'
            );
            imageReponse.txt.setText(
                this.getText('Mission3', this.isCorrect ? 'bonneReponse' : 'mauvaiseReponse')
            );

            this.input.enabled = false;

            this.tweens.add({
                targets: imageReponse,
                scale: 1,
                alpha: 1,
                duration: 500,
                ease: 'Back.Out',
            });

            this.time.delayedCall(1000, () => {
                this.tweens.add({
                    targets: imageReponse,
                    scale: 0,
                    alpha: 0,
                    duration: 300,
                    ease: 'Back.In',
                    onComplete: () => {
                        this.input.enabled = true;
                        this.checkAnswer();
                        this.btnValider && this.updateValiderButtonState();
                    },
                });
            });
        });
    }

    showChaineAlimentaireComplete() {
        this.destroyScene();
        // a changer plus tard dans le excel
        this.imagesChaineAlimentaire = this.missionData.imagesChaineAlimentaire;
        this.chaineImagesPositions = [
            { x: 800, y: 0 },
            { x: 1500, y: 0 },
            { x: 1700, y: 0 },
            { x: 2300, y: 0 },
            { x: 2600, y: 0 },
            { x: 3200, y: -150 },
            { x: 3700, y: -150 },
            { x: 3200, y: 200 },
            { x: 3700, y: 300 },
            { x: 4400, y: 0 },
            { x: 4700, y: 0 },
        ];
        this.chaineContainer = this.add.container(0, 0);
        this.chaineImageObjects = [];

        for (let i = 0; i < this.imagesChaineAlimentaire.length; i++) {
            const { x, y } = this.chaineImagesPositions[i];
            const textureKey = this.imagesChaineAlimentaire[i];

            const img = this.add
                .image(x, y, textureKey)
                .setOrigin(0, 0.5)
                .setAlpha(i === 0 ? 1 : 0); // seule la 1ère est visible

            this.chaineContainer.add(img);
            this.chaineImageObjects.push(img);
        }
        const img0 = this.chaineImageObjects[0];
        const offset = this.cameras.main.centerX - img0.x;
        const offsetY = this.cameras.main.centerY - img0.y;
        this.chaineContainer.x = offset;
        this.chaineContainer.y = offsetY;

        this.time.delayedCall(1000, () => {
            this.animateChaineStep(1);
        });
    }

    animateChaineStep(i) {
        if (i >= this.chaineImageObjects.length) {
            this.time.delayedCall(1000, () => {
                this.showEndScreen();
            });
            return;
        }
        this.input.enabled = false;

        const target = this.chaineImageObjects[i];
        const targetX = target.x;
        const targetY = target.y;
        const offset = this.cameras.main.centerX - targetX;
        const offsetY = this.cameras.main.centerY - targetY;

        // 👇 Déplace le container
        this.tweens.add({
            targets: this.chaineContainer,
            x: offset,
            y: offsetY,
            duration: 1000,
            ease: 'Sine.easeInOut',
            onComplete: () => {
                // 👇 Puis fait apparaître l'image
                this.tweens.add({
                    targets: target,
                    alpha: 1,
                    duration: 400,
                    ease: 'Sine.easeIn',
                    delay: 200,
                    onComplete: () => {
                        this.time.delayedCall(400, () => {
                            this.animateChaineStep(i + 1);
                        });
                    },
                });
            },
        });
    }

    checkAnswer() {
        if (this.isCorrect) {
            const currentSlide = this.slider.slides[this.slider.currentIndex];
            if (currentSlide.tagReponseImage) {
                currentSlide.tagReponseImage.setAlpha(1);
            }
            this.showCorrectLetterAnimation();

            const missionDataConsignes = [
                this.getText('Mission3', 'groupeChaine0'),
                this.getText('Mission3', 'groupeChaine1'),
                this.getText('Mission3', 'groupeChaine2'),
                this.getText('Mission3', 'groupeChaine3'),
                this.getText('Mission3', 'groupeChaine4'),
                this.getText('Mission3', 'groupeChaine5'),
            ];

            if (this.currentIndex < missionDataConsignes.length - 1) {
                this.currentIndex++;
                this.slider.moveTo(0);
            } else {
                this.showEnd = true;
            }
            this.hideAndMoveScene();
        }
        this.isCorrect = false;
    }

    updateValiderButtonState() {
        if (!this.btnValider || !this.slider) return;

        const currentSlide = this.slider.slides[this.slider.currentIndex];
        const isUsed = currentSlide?.tagReponseImage?.alpha === 1;

        if (!isUsed) {
            this.btnValider.setUnlocked?.();
        } else {
            this.btnValider.setLocked?.();
        }
    }

    showCorrectLetterAnimation() {
        const originalX = this.bouteilleActivite.x;
        const originalY = this.bouteilleActivite.y;

        const letter = this.getText('Mission3', `lettre${this.currentIndex}`);

        const oldLetters = this.feedbackLetters ? [...this.feedbackLetters] : [];

        const positions = this.missionData.lettresPositions;
        const letterIndex = this.feedbackLetters?.length || 0;

        const centerPos = positions.center[letterIndex];
        const bottomPos = positions.bottom[letterIndex];

        this.tweens.add({
            targets: [this.bouteilleActivite, ...oldLetters],
            x: (target) => {
                if (target === this.bouteilleActivite) return this.width / 2;
                const i = this.feedbackLetters.indexOf(target);
                return positions.center[i].x;
            },
            y: (target) => {
                if (target === this.bouteilleActivite) return this.height / 2;
                const i = this.feedbackLetters.indexOf(target);
                return positions.center[i].y;
            },
            scale: (target) => (target === this.bouteilleActivite ? 1.2 : 1),
            ease: 'Sine.easeInOut',
            duration: 500,
            onComplete: () => {
                const letterText = this.add
                    .text(centerPos.x, centerPos.y, letter, {
                        fontSize: Sizes.Text.h3,
                        color: Colors.Text.White,
                        fontFamily: 'Binx',
                    })
                    .setOrigin(0.5)
                    .setAlpha(0)
                    .setScale(0.5);

                this.tweens.add({
                    targets: letterText,
                    alpha: 1,
                    scale: 1,
                    ease: 'Back.Out',
                    duration: 300,
                });

                this.time.delayedCall(1000, () => {
                    letterText.finalX = bottomPos.x;
                    letterText.finalY = bottomPos.y;
                    this.tweens.add({
                        targets: [
                            this.bouteilleActivite,
                            ...(this.feedbackLetters || []),
                            letterText,
                        ],
                        x: (target) =>
                            target === this.bouteilleActivite ? originalX : target.finalX,
                        y: (target) =>
                            target === this.bouteilleActivite ? originalY : target.finalY,
                        scale: 1,
                        ease: 'Sine.easeInOut',
                        duration: 500,
                        onComplete: () => {
                            if (!this.feedbackLetters) this.feedbackLetters = [];
                            this.feedbackLetters.push(letterText);
                            this.xOffset += 22;

                            if (this.showEnd) {
                                this.showChaineAlimentaireComplete();
                            }
                        },
                    });
                });
            },
        });
    }

    hideSlider() {
        this.tweens.add({
            targets: [
                this.slider,
                this.btnValider,
                this.consigneJeuPart1,
                this.consigneJeuPart2,
                this.consigneJeuPart3,
                this.whiteRectangle,
            ],
            alpha: 0,
            duration: 500,
            ease: 'Sine.easeInOut',
        });
    }
    hideAndMoveScene() {
        if (this.slider) {
            this.tweens.add({
                targets: [
                    this.slider,
                    this.btnValider,
                    this.consigneJeuPart1,
                    this.consigneJeuPart2,
                    this.consigneJeuPart3,
                    this.whiteRectangle,
                ],
                alpha: 0,
                duration: 500,
                ease: 'Sine.easeInOut',
                onComplete: () => {
                    this.consigneJeuPart1.destroy();
                    this.consigneJeuPart2.destroy();
                    this.consigneJeuPart3.destroy();
                    this.whiteRectangle.destroy();
                    if (this.addChaineAlimentaire && !this.showEnd) {
                        this.tweens.add({
                            targets: this.addChaineAlimentaire,
                            x: this.ombreXPositions[this.currentIndex],
                            y: this.ombreYPositions[this.currentIndex],
                            delay: 1500,
                            duration: 800,
                            ease: 'Sine.easeInOut',
                            onComplete: () => {
                                this.addSliderText();
                                this.tweens.add({
                                    targets: [this.slider, this.btnValider],
                                    alpha: 1,
                                    duration: 500,
                                    ease: 'Sine.easeInOut',
                                });
                            },
                        });
                    }
                },
            });
        }
    }

    destroyScene() {
        this.slider.destroy();
        this.btnValider.setAlpha(0);
        this.bouteilleActivite.destroy();
        this.consigneJeuPart1.destroy();
        this.consigneJeuPart2.destroy();
        this.consigneJeuPart3.destroy();
        this.whiteRectangle.destroy();
        this.addChaineAlimentaire.destroy();

        // Set feedbackLetters alpha to 0 before clearing
        if (this.feedbackLetters && this.feedbackLetters.length > 0) {
            this.feedbackLetters.forEach((letter) => {
                if (letter && letter.setAlpha) {
                    letter.setAlpha(0);
                }
            });
        }

        this.currentIndex = 0;
    }

    showEndScreen() {
        const duration = 500;
        const elements = [];

        const blocker = this.add.rectangle(
            this.width / 2,
            this.height / 2,
            this.width,
            this.height,
            Colors.Elmt.Beige,
            1
        );

        // Nav (titre-nav-activite-1) – commence plus haut
        const navTitre = this.add.existing(
            new NavTitre(this, 200, 0, '3', this.getText('Mission3', 'titre'), this.scaleX)
        );

        navTitre.showWithAnimation();

        // ➡️ Titre avec animation spéciale
        const title = this.add
            .text(this.width / 2, this.height / 2 - 220, this.getText('Mission3', 'endTitre'), {
                fontSize: Sizes.Text.h1,
                color: Colors.Text.BleuNovotel,
                fontFamily: 'Binx',
            })
            .setOrigin(0.5)
            .setAlpha(0)
            .setScale(0);

        // ➡️ Autres éléments à animer ensuite
        const text1 = this.add
            .text(this.width / 2, this.height / 2 - 150, this.getText('Mission3', 'endTexte'), {
                fontSize: Sizes.Text.p,
                color: Colors.Text.DarkBlue,
                fontFamily: 'Monteserrat',
            })
            .setOrigin(0.5)
            .setAlpha(0)
            .setScale(0.5);

        this.addBouteille('Mission3');

        const icone = this.add
            .image(this.width / 2 - 390, this.height / 2 + 190, 'attention')
            .setAlpha(0)
            .setScale(0.5);

        const text2 = this.add
            .text(this.width / 2, this.height / 2 + 200, this.getText('Mission3', 'endTexte2'), {
                fontSize: Sizes.Text.p,
                color: Colors.Text.DarkBlue,
                fontFamily: 'Monteserrat',
                align: 'center',
                wordWrap: { width: 368 * 2 },
            })
            .setOrigin(0.5)
            .setAlpha(0)
            .setScale(0.5);

        elements.push(text1, this.bouteille, this.textBouteille, icone, text2);

        // ➡️ Bouton
        const button = this.add
            .existing(
                new ButtonRounded(
                    this,
                    this.width - 64 - 64,
                    this.height - 32 - 32,
                    86 * 2,
                    32 * 2,
                    this.getText('Mission3', 'buttonLabel1'),
                    Colors.Text.White,
                    Colors.Elmt.BleuNovotel,
                    false,
                    Colors.Text.White,
                    true,
                    false,
                    'arrow-right-white',
                    null
                )
            )
            .setAlpha(0)
            .setScale(0.5);

        elements.push(button);

        button.setInteractive({ cursor: 'pointer' }).on('pointerdown', () => {
            this.scene.start('Mission4');
        });

        // ➡️ Animation du titre : scale up + down + fade in
        this.tweens.add({
            targets: title,
            alpha: 1,
            scale: 1.2,
            duration: duration,
            ease: 'Back.Out',
            onComplete: () => {
                // ➡️ Retour à scale 1 (rebond)
                this.tweens.add({
                    targets: title,
                    scale: 1,
                    duration: 300,
                    ease: 'Back.Out',
                    onComplete: () => {
                        // ➡️ Quand le titre est fini : animer les autres éléments en cascade
                        elements.forEach((el, index) => {
                            this.tweens.add({
                                targets: el,
                                alpha: 1,
                                scale: 1,
                                ease: 'Back.Out',
                                duration: duration,
                                delay: index * 150,
                            });
                        });
                        this.input.enabled = true;
                    },
                });
            },
        });
    }

    formatTime(seconds) {
        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
    }
}
